import { weakMapMemoize } from '@reduxjs/toolkit';
import { ComponentInstance } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';

/**
 * Returns mapping where keys are component IDs and values are parent component instances
 * for an instance with that specific ID. The mapping is built by traversing the given
 * component hierarchy.
 *
 * @param rootComponent root component of the hierarchy
 * @returns mapping from component instance IDs to parent component instances
 */
const getComponentInstanceParentMappingByIds = weakMapMemoize(
  (rootComponent: ComponentInstance | null | undefined): Record<string, ComponentInstance> => {
    const mapping: Record<string, ComponentInstance> = {};
    if (!rootComponent) return mapping;
    rootComponent.children.forEach((child) => {
      mapping[child.id] = rootComponent;
      Object.assign(mapping, getComponentInstanceParentMappingByIds(child));
    });
    return mapping;
  },
);

export default getComponentInstanceParentMappingByIds;
